export default __webpack_public_path__ + "static/media/logo-text-light.84b1c332.svg";